<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'master-shippingMark',
  components: { PageTable },
}
</script>
